
import React from 'react';
import { Card, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { CheckCircle } from 'lucide-react';

const StripeIntegrationInfo: React.FC = () => {
  return (
    <Card className="mt-6">
      <CardHeader>
        <CardTitle className="flex items-center">
          <CheckCircle className="h-5 w-5 text-green-600 mr-2" />
          Stripe Integration Status
        </CardTitle>
        <CardDescription>
          Your Stripe integration is active and functioning correctly.
        </CardDescription>
      </CardHeader>
    </Card>
  );
};

export default StripeIntegrationInfo;
